import React, { useState, useEffect, Link } from 'react';
import axios from 'axios';
import { Cookies } from '../../index.js';
import Products from './store.jsx';
import { auth, doc, where, query, collection, db, onSnapshot } from '../../js/firebase.js';
import { useNavigate, Outlet } from 'react-router-dom';
import ProfileNav from './ProfileNav.jsx';
import Buyaccount from './Buyaccount.jsx';
import { alert_error, alert_success } from '../../AppContext.js';
import Select from "react-select";
import AdSense from 'react-adsense';
import AdModal from '../../app_structure/AdModal';
function Editcategory() {
  const [showAd, setShowAd] = useState(true);
  const handleCloseAd = () => {
    setShowAd(false);
  };
  const [inputcaption, setinputcaption] = useState('');
  const [social, setSocial] = useState('');
  const [iduser, setiduser] = useState(null);
  const [theloai, settheloai] = useState('');
  const [damoshop, setdamoshop] = useState(Cookies.get('damoshop'));
  const [nutorder, setnutorder] = useState('✔️ Click to Confirm');
  const [thanhcong2, setthanhcong2] = useState('');
  const [nutxuly, setnutxuly] = useState(0);
  const [inputlienket, setinputlienket] = useState('');
  const [chedo, setchedo] = useState('');
  const [store_data, setstore_data] = useState('');
  const [show_edit_store, setshow_edit_store] = useState(false);
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(true);
  const [isDisabled, setIsDisabled] = useState(false);
  const [options, setoptions] = useState([
    {
      id: '', stt: '', name: 'Chọn 1 thể loại của bạn',
      money: '', status: 'show', content: '', servicecode: ''
    }
  ]);
  const [options2, setoptions2] = useState([
    {
      id: '', stt: '', name: 'Chọn 1 dịch vụ của bạn',
      money: '', status: 'show', content: '', servicecode: ''
    }
  ]);
  const [options3, setoptions3] = useState([
    { value: '', name: 'Chọn 1 cách làm của bạn' }
    , { value: 'edit', name: 'Sửa gian hàng của bạn' }
    , { value: 'add', name: 'Thêm gian hàng mới' }
  ]);
  const [options4, setoptions4] = useState([
    { value: '', name: 'Chọn 1 gian hàng cần sửa' }
  ]);
  const handleOptionChange2 = (event) => {
    const selectedOption = event.target.value;

    setchedo(selectedOption);
    console.log(selectedOption);
  };
  const handleOptionChange3 = (selectedOption) => {
    setIsOpen(false);
    if (selectedOption) {
      const selectedValue = selectedOption.value;
      console.log(selectedValue);
      // const selectedOptionOk = options.find((option) => option.value === selectedValue);
      settheloai(selectedValue);
      // Add other actions here based on the user's selection
    }
  }
  const handleOptionChange4 = (event) => {
    const selectedOption = event.target.value;
    setinputlienket(selectedOption);
    // console.log(selectedOption);
  };
  const handleOptionChange = (event) => {
    const domain = window.location.hostname;
    const selectedOption = event.target.value;
    const selectedOptionok = options.find((option) => option.id == selectedOption);
    console.log(selectedOptionok);
    console.log(selectedOptionok.option);
    //   setcontent(selectedOptionok.category);
    axios
      .post('https://hust.media/getservice/service5.php', {
        chedo: 'service',
        domain: domain,
        category: selectedOptionok.option
      })
      .then(response => laydichvu(response))
      .catch(error => console.log(error))
    // Thêm các hành động khác tại đây dựa trên lựa chọn của người dùng
  }
  function laydichvu(response) {
    const arr1 = [
      {
        id: '', stt: '', name: 'Chọn 1 dịch vụ mà bạn cung cấp dịch vụ',
        money: '', status: 'show', content: '', servicecode: ''
      }
    ];

    const arr2 = response.data;

    setoptions2(arr1.concat(arr2));
  }
  function gopdulieu(response) {
    const arr1 = [
      {
        id: '', stt: '', name: 'Chọn 1 thể loại mà bạn cung cấp dịch vụ',
        money: '', status: 'show', content: '', servicecode: ''
      }
    ];

    const arr2 = response.data;

    setoptions(arr1.concat(arr2));

  }
  function laydulieu() {
    const dfsdfsdf = Cookies.get('damoshop');
    const domain = window.location.hostname;
    console.log(dfsdfsdf);
    setdamoshop(dfsdfsdf);

    axios
      .post('https://hust.media/getservice/service5.php', {
        chedo: 'category',
        domain: domain,
        category: 'web'
      })
      .then(response => gopdulieu(response))
      .catch(error => console.log(error))


  }
  function testFunction(response) {
    const info = response.data;
    const status = info.status;
    const message = info.message;
    setnutorder('đặt tiếp luôn nào')
    setnutxuly(0);
    if (status == 0) {
      alert_error(info.message);
    }
    else if (status == 1) {
      alert_success(info.message);
    }
    if (info.redirect != null && info.redirect != '') {
      setTimeout(function () {
        // Chuyển hướng sang trang web khác
        window.location.href = info.redirect;
      }, 1700);
    }
  };
  function handleSubmit(event) {
    setnutxuly(0);
    const apikey = Cookies.get('apikey');
    event.preventDefault();

    setnutxuly(1);
    setnutorder('Please wait a moment 😊');
    if (!inputcaption) {
      alert('Please điền đầy đủ thông tin')
      setnutxuly(0);
      setnutorder('điền đủ thông tin');
      return
    }
    else if (!chedo || !theloai) {
      alert('Thiếu hình thức hoặc thiếu dịch vụ')
      setnutxuly(0);
      setnutorder('điền đủ thông tin');
      return
    }
    axios
      .post('https://hust.media/nosql/addservice.php', {
        lienket: inputlienket,
        key: apikey,
        caption: inputcaption,
        chedo: 'addstore',
        theloai: theloai,
        service: chedo
      })
      .then(response => (testFunction(response)))
      .catch(error => {
        setnutorder('đặt tiếp luôn nào');
        setnutxuly(0);
        alert_error(error);
      })
  }

  function saochep(value) {
    alert_success('Đã sao chép');
    window.saochepnative(value);

  };

  const getUserByUsername = async () => {
    const userRef = db.collection('store').doc('a6Jlf80GnjvNg3CBQ5kj2SNwmyjsbbshshsns');

    userRef.onSnapshot((doc) => {
      if (doc.exists) {
        console.log(doc.data());
      } else {
        console.log('No such document!');
      }
    });
  }
  function laythongtin() {
    const myCookieValue = Cookies.get('apikey');
    const apidata = {
      apikey: myCookieValue,
      chedo: 'laythongtin',
      dulieu: 'shop',
    }
    const headers = {
      'Content-Type': 'application/json',
    }
    axios
      .post('https://hust.media/api/account.php', apidata, headers)
      .then((response) => {
        setiduser(response.data.iduser);
        console.log(response.data.iduser);

      })
      .catch((error) => {
        alert_error(error)
      })
  };
  const handleFocus = () => {
    setIsOpen(true);
    console.log(123);
  };
  const handleBlur = () => {
    setIsOpen(false);
  };
  const handleMenuOpen = () => {
    setIsOpen(true);
  };

  useEffect(() => {
    // Thực hiện các hành động liên quan đến giá trị đã chọn tại đây
  }, [social]);
  useEffect(() => {
    laydulieu();
    laythongtin();
  }, []);

  useEffect(() => {
    console.log('store_data changed:', store_data);
    // Kiểm tra xem store_data có phải là mảng không
    const isArrayOfObjects = Array.isArray(store_data) && store_data.every(item => typeof item === 'object');

    // Log kết quả kiểm tra
    console.log('Is store_data an array of objects?', isArrayOfObjects);
    setshow_edit_store(isArrayOfObjects);
    if (isArrayOfObjects) {
      const transformedArray = store_data.map(item => {
        // Tạo một đối tượng mới với các thuộc tính đã đổi tên
        return {
          value: item.id,
          name: item.id,
          // Thêm các thuộc tính khác nếu cần
        };
      });
      setoptions4(transformedArray);
      console.log(transformedArray);
    }
    // Thực hiện các công việc khác tại đây nếu cần
  }, [store_data]);

  return (
    <>        <div>
      {/* <AdModal isOpen={showAd} onClose={handleCloseAd} /> */}

      <div className="mt-2">
        {/* <br /> */}

        {window.location.pathname.startsWith("/shop/editcategory/buyaccount")
          ? (
            <>
              <Buyaccount />
            </>

          ) : (<>
            <AdModal isOpen={showAd} onClose={handleCloseAd} />
            <form className="add-form">
              <div className="form-control">
                <label>Chọn hình thức gian hàng của bạn</label>
                {/* <select
                    id="countries1"
                    className="selectpicker sp1 form-control"
                    onChange={handleOptionChange3}
                  >
                    {options3.map((option) => (
                      <option value={option.value}>
                        {option.name}
                      </option>
                    ))}
                  </select> */}
                <Select
                  classNamePrefix="Chọn 1 lựa chọn"
                  onFocus={handleFocus}
                  options={options3.map((option) => ({
                    value: option.value,
                    label: `${option.name}`,
                  }))}
                  menuIsOpen={isOpen}
                  isDisabled={isDisabled}
                  onBlur={handleBlur}
                  onMenuOpen={handleMenuOpen}
                  onChange={handleOptionChange3}
                  isLoading={false}
                  isClearable={true}
                  isRtl={false}
                  isSearchable={false}
                />
                <label>Chọn thể loại mặt hàng của bạn</label>
                <select
                  id="countries1"
                  className="selectpicker sp1 form-control"
                  onChange={handleOptionChange}
                >
                  {options.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </select>
                <label>Chọn dịch vụ mà bạn cung cấp</label>
                <br />
                <select
                  id="countries2"
                  className="selectpicker sp2 form-control"
                  onChange={handleOptionChange2}
                  value={chedo}
                >
                  {options2.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </select>

                <div v-if="cocaption" >
                  <label>Tạo tiêu đề ngọt ngào cho bài đăng bán hàng của bạn: (Tiêu đề dễ thương và thông tin rõ ràng cho sản phẩm của bạn)</label>
                  <br />
                  <div className="input-group flex-nowrap">
                    <span className="input-group-text" id="addon-wrapping">Captions</span>
                    <input
                      onChange={e => setinputcaption(e.target.value)}
                      value={inputcaption} type="text" className="form-control"
                      placeholder="VD: DỊCH VỤ FACEBOOK (FOLLOW-LIKE-CMT)-giá rẻ uy tín" aria-label="inputcaption" name="inputcaption" aria-describedby="addon-wrapping">
                    </input>    </div>

                </div>
                {show_edit_store && theloai == 'edit' && (<>
                  <label>id gian hàng xem ở dưới</label>
                  <br />
                  <select
                    id="countries2"
                    className="selectpicker sp2 form-control"
                    onChange={handleOptionChange4}
                    value={inputlienket}
                  >
                    <option value="">-- Chọn một --</option>
                    {options4.map((option) => (
                      <option key={option.id} value={option.id}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                </>)
                }

              </div>

              {/* <p>
                  {content}
                </p> */}
              <div className="max-h-16">
                <div className="cards">
                  <AdSense.Google
                    client="ca-pub-4574266110812955"
                    slot="1627514116"
                    style={{ display: 'block', height: 50 }}
                    format=""
                  /> </div>
              </div>
              <button disabled={nutxuly} onClick={handleSubmit}
                className='flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-2 w-full dark:bg-slate-800 dark:text-white'>
                <div className='flex items-center justify-between flex-1'>
                  {nutxuly == 1 &&
                    <div className="spinner-border" role="status">

                    </div>}


                  <span className='text-lg font-medium text-white'>
                    {nutorder} </span>
                    <div className="text-xl">
                                        {'\u27A4'}
                                    </div>
                </div>
              </button>
            </form>
            {thanhcong2 != '' && <>
              <div className="relative py-3 sm:max-w-xl sm:mx-auto">
                <div className="flex flex-col items-center justify-center py-2">
                  <div className="absolute inset-0 bg-gradient-to-r from-indigo-200 to-purple-600 shadow-lg transform rotate-6 rounded-3xl">

                  </div>
                  <div className="relative px-4 py-10 bg-white shadow-lg sm:rounded-3xl sm:p-20">
                    <h2 className="text-3xl text-break font-bold">
                      kết quả {thanhcong2} </h2></div></div></div>
              <button onClick={() => saochep(thanhcong2)} className="bg-pink-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full">
                Sao chép
              </button> </>}
            {iduser && (<Products setstore_data={setstore_data} iduser={iduser} />)}
          </>)}
      </div>

      <br></br>
    </div>    </>
  )
}

export default Editcategory;